import { render } from "./RoleIndex.vue?vue&type=template&id=76f805f4"
import script from "./RoleIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/role/components/RoleIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76f805f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76f805f4', __exports__)) {
    api.reload('76f805f4', __exports__)
  }
  
  module.hot.accept("./RoleIndex.vue?vue&type=template&id=76f805f4", () => {
    api.rerender('76f805f4', render)
  })

}


export default __exports__